<template>
  <el-dialog
    :close-on-click-modal="false"
    title="标记"
    :visible.sync="visible"
    width="540px"
    class="auditOrder"
    :before-close="handleClose"
  >
    <el-form :model="orderData" ref="form" label-width="80px">
      <el-form-item label="标记内容：" style="width: 100%;">
        <el-select size="small" clearable v-model="form.remarkType">
          <template v-for="(value, key) in dictData['remarkType']">
            <el-option
              :key="value.value"
              :label="value.label"
              :value="value.value"
            ></el-option>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item
        v-if="dictMap['remarkType'][form.remarkType] == '其他'"
        label="补充信息："
        style="width: 100%;"
      >
        <el-input
          v-model="form.remarkContent"
          class="input"
          size="small"
          type="textarea"
          :rows="6"
        />
      </el-form-item>
      <el-form-item label="颜色：" prop="delivery">
        <div slot="label">
          颜色：
        </div>
        <ul class="background-color-content">
          <el-tooltip
            v-for="(color, idx) in textColorList"
            :key="idx"
            effect="dark"
            :content="color.hex"
            placement="top"
          >
            <li
              class="background-color-item"
              :style="{ background: color.hex }"
              @click="selectTextColor(color, idx)"
              style="position: relative"
            >
              <i
                class="el-icon-check"
                style="position: absolute; top: 5px; left: 5px"
                :style="{
                  color: form.remarkColor == '#ffffff' ? '#171717' : '#ffffff',
                }"
                v-if="form.remarkColor === color.hex"
              ></i>
            </li>
          </el-tooltip>
        </ul>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose" size="small">返回</el-button>
      <el-button type="danger" @click="deleteLabel" size="small">
        删除
      </el-button>
      <el-button type="primary" @click="sure" size="small">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { setOrderRemark, deleteOrderRemark } from "@/api/order/all"
import { mapGetters } from "vuex"
export default {
  name: "LabelDialog",
  data() {
    return {
      form: {
        remarkIds: "",
        remarkType: "",
        remarkContent: "",
        remarkColor: "black",
      },
      textColorList: [
        {
          hex: "#171717",
          name: "black",
        },
        {
          hex: "#00FFFF",
          name: "cyan",
        },
        {
          hex: "#a1a1a1",
          name: "grey",
        },
        {
          hex: "#9c6a23",
          name: "brown",
        },
        {
          hex: "#d82424",
          name: "red",
        },
        {
          hex: "#ee6419",
          name: "orange",
        },
        {
          hex: "#50b03c",
          name: "green",
        },
        {
          hex: "#035239",
          name: "darkGreen",
        },
        {
          hex: "#192c7c",
          name: "blue",
        },
        {
          hex: "#3f92db",
          name: "sky",
        },
        {
          hex: "#934b7c",
          name: "purple",
        },
        {
          hex: "#ffde00",
          name: "yellow",
        },
      ],
    }
  },
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      },
    },
    remarkIds: {
      type: String,
      default() {
        return ""
      },
    },
    orderRemark: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  computed: {
    ...mapGetters(["dictData", "dictMap", "user"]),
  },
  watch: {
    visible() {
      if (!this.visible) {
        this.form = {
          remarkIds: "",
          remarkType: "",
          remarkContent: "",
          remarkColor: "#171717",
        }
      } else {
        if (this.orderRemark.appId) {
          this.form.remarkType = this.orderRemark.remarkType
          this.form.remarkContent = this.orderRemark.remarkContent
          this.form.remarkColor = this.orderRemark.remarkColor
        }
      }
    },
  },
  methods: {
    sure() {
      if (this.form.remarkType == "") {
        this.$message.error("请选择标记内容")
        return
      }

      setOrderRemark({
        appId: this.remarkIds,
        remarkType: this.form.remarkType,
        remarkContent: this.form.remarkContent,
        remarkColor: this.form.remarkColor,
      }).then((res) => {
        if (res.code !== 200) {
          this.$message.error("提交失败")
        } else {
          this.$message.success("提交成功")
          this.$emit("onOk")
        }
      })
    },
    deleteLabel() {
      deleteOrderRemark(this.remarkIds).then((res) => {
        if (res.code !== 200) {
          this.$message.error("提交失败")
        } else {
          this.$message.success("删除成功")
          this.$emit("onOk")
        }
      })
    },
    selectTextColor(color, idx) {
      this.form.remarkColor = color.hex
    },
    handleChange() {},
    handleClose() {
      this.$emit("onClose")
    },
  },
}
</script>

<style scoped>
.auditOrder {
  font-size: 12px;
}
.item {
  display: flex;
  flex-wrap: wrap;
}

.tip {
  margin-top: 10px;
  font-size: 12px;
  text-align: center;
}

.tip .store-info-icon {
  display: inline-block;
  padding: 0 0 0 5px;
  background: #129ba7;
  color: #fff;
  border-radius: 2px;
  margin-right: 5px;
  line-height: 1.4;
}

.blue {
  color: #129ba7;
}

.background-color-content {
  position: relative;
  max-width: 209px;
  padding: 0.64em 0 0 0.64em;
  background: #fff;
  border: 1px solid #ebebeb;
  border-radius: 4px;
  flex-wrap: wrap;
  align-content: flex-start;
  display: flex;
}

.background-color-content .background-color-item {
  width: 24px;
  height: 24px;
  border: 1px solid #f2f2f2;
  border-radius: 4px;
  cursor: pointer;
  margin: 0 0.64em 0.64em 0;
  list-style: none;
  box-sizing: border-box;
}
</style>
